module.exports = __webpack_public_path__ + "img/gift_pantene.ce251103.png";